import {default as _} from 'lodash';
import { ActivatedRoute,Router } from '@angular/router';
import { DatePipe,DOCUMENT, LowerCasePipe, NgClass, CommonModule } from '@angular/common';
import { SharedHttpClientService } from './../../../Shared/Services/shared-http-client.service';
import { UrlsService } from './../../../Shared/Services/urls.service';
import { Component, OnInit, ViewChild, OnDestroy, Inject, forwardRef } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { APIURL } from '../../../Shared/Constant/API_Urls';
import { GridService } from '../../../Shared/Services/grid.service';
import { UserService } from '../../../Shared/Services/user.service';
import {default as GridColumnsJSON} from 'app/Shared/Constant/Grid Column Names/CAT-ROE-Viewer-Columns.json';
import {default as Timecombo} from 'app/Shared/Constant/TimeDropDown.json';
import { EmitterService } from 'app/Shared/Services/emitter.service';
import { map, Subscription } from 'rxjs';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { Table, TableModule } from 'primeng/table';
import { MessageService,ConfirmationService } from 'primeng/api';
import { DataService } from 'app/Shared/Services/data.service';
import { SortPipe } from 'app/Shared/Component/pipes/sort.pipe';
import { EventTreeService } from 'app/Shared/Component/event-tree/event-tree.service';
import saveAs from 'file-saver';
import { MatChipsModule } from '@angular/material/chips';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FilterPanelComponent } from 'app/Shared/Component/filter-panel/filter-panel.component';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ExportToCSVSComponent } from 'app/Shared/Component/export-to-csv/export-to-csv.component';
import { SingleEditFormComponent } from 'app/Shared/Component/single-edit-form/single-edit-form.component';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { AuditTrailDialogComponent } from 'app/Shared/Component/audit-trail/audit-trail-dialog.componenet';
import { EventTreeDialogComponent } from 'app/Shared/Component/event-tree/event-tree-dialog.componenet';
import { DialogModule } from 'primeng/dialog';
import { SymbolPanelComponent } from 'app/Shared/Component/symbol-panel/symbol-panel.component';
import { NewROEEntryComponent } from 'app/Shared/Component/new-roe-entry/new-roe-entry.component';
import { RepresentativeOrderComponent } from './representative-order/representative-order.component';
import { MultiLegEventComponent } from "./multileg-event/multileg-event.component";
import { QuickSearchComponent } from "app/Shared/Component/quick-search/quick-search.component";
import { asBlob, generateCsv } from 'export-to-csv';
import { ToastModule } from 'primeng/toast';
import { Select } from 'primeng/select';
import { ContextMenu, ContextMenuModule } from 'primeng/contextmenu';
import { GridCommonService } from 'app/Shared/Services/grid-common.service';

@Component({
    selector: 'app-cats-roe-viewer',
    imports: [NgClass, CommonModule, ButtonModule, MatTooltipModule, TableModule, MatExpansionModule,
        FilterPanelComponent, MatProgressSpinnerModule, MatChipsModule,
        MatExpansionModule, LowerCasePipe,ContextMenuModule,
        ConfirmDialogModule, ExportToCSVSComponent, Select, FormsModule, SingleEditFormComponent,
        AuditTrailDialogComponent, DialogModule, EventTreeDialogComponent, SymbolPanelComponent, NewROEEntryComponent,
        RepresentativeOrderComponent, MultiLegEventComponent, QuickSearchComponent, ToastModule],
    templateUrl: './cats-roe-viewer.component.html',
    styleUrls: ['./cats-roe-viewer.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => CatsRoeViewerComponent),
        }
    ]
})
export class CatsRoeViewerComponent implements OnInit, OnDestroy {
  @ViewChild(('dt')) dt!: Table | any;
  @ViewChild(('newROEentry')) newROEentry:any;
  @ViewChild(('id_newROEEntry')) id_newROEEntry :any;
  @ViewChild('cm') contextMenuItems!: ContextMenu;
  filterFieldDefaultValues: any = new Object();
  quickFilterArray: any = GridColumnsJSON["CAT-ROE-Quick-Search-Fields"];
  GridColumns: any = GridColumnsJSON["CAT-ROE-Grid-Columns"];
  exportGridColumns: any = [];
  dataset1: any[] = [];
  ApplicationName: any = '';
  urlEncodedFilterParams: object | any = new Object();
  LastExecutionCATDate!: any[];
  ActiveSymbol: any;
  SymbolsArray: any = [];
  multiLegEventArray: any = [];
  quickFilterEventType: any;
  quickFilterEventTypeArray: any = [];
  DefaultFilterArray: any = [];
  isLoadingResults = true;
  CATFieldTypesArrayList: any = [];
  Limit: any = { 'Start': '', 'End': '' };
  previousLimit: any = { 'Start': '', 'End': '' };
  rowsPerPageOptions: any = [];
  totalRecords: any;
  rowcount!: number;
  startLimit: any = 0;
  endLimit!: number;
  tbldatamsg = 'L o a d i n g . . . . .';
  cols: any = []
  filterCols: any = [];
  selectedRow: any = [];
  edit: boolean;
  TimeDropDown: any;
  pageNumber: any = 1;
  priviousStartLimit: any;
  rowDataforDialog: any;
  rowIndexForDialog!: number;
  actionType!: string;
  subscription!: Subscription;
  isMultiEdit: boolean = false;
  correctCodeLength: number = 0;
  firmROEIDList: Array<string> = [];
  isExportToJSON!: boolean;
  sortData: any = { field: '', order: 0 };
  sortClickCounter: number = 0;
  defaultData: any;
  isRepresentativeOrderDisplay:boolean=false;
  isAuditTrail!: boolean;
  applicationFilters: any;
  optedApplicationFilter: any = new Object();  
  public viewMultiLegEvent: boolean;
  defaultCATEvents: any = ["MENO","MONO","MLNO","MEOA","MOOA","MLOA"];
  eventList: any[] = [];
  originalEvent!: string[];
  selectedEventType:any;
  selectedID:any;
  selectedReportDate:any;
  existingEventType:any;
  selectedGroupName:any;
  CATReporterIMID:any;
  public pageName:any;
  groupName:any;
  public displayNewROEDialog:any;
  isOpenClose:any;
  public displayTildCount:boolean = false;

  constructor(public UserService: UserService,
    private urlService: UrlsService,
    private gridService: GridService,
    private messageService: MessageService,
    public commonColService:GridCommonService,
    public confirmationService: ConfirmationService,
    public constantService: ConstantService,
    public dataService: DataService,
    private datePipe: DatePipe,
    private emitterService: EmitterService,
    private router: Router,
    private sortPipe: SortPipe,
    private activatedRoute: ActivatedRoute,
    private sharedHttpClientService: SharedHttpClientService,
    public eventTreeService:EventTreeService,
    @Inject(DOCUMENT) document: Document
  ) {
    this.getFieldDictionary();
    this.cols = [];
    this.filterCols = [];
    this.edit = false;
    this.TimeDropDown = Timecombo;
    this.viewMultiLegEvent = false;
    this.ApplicationName = this.constantService.getApplicationName();
    this.urlEncodedFilterParams = this.dataService.getViewerEncodedURLParameters(); // Decode URL Params passed from CAT Analytics | Firmwide CAT Summary from CAT Screen
    this.multiLegEventArray = this.gridService.getMultiLegEventTypes();
    let originalEvent = this.constantService.CONVERT_EVENT_LIST.replace(/ /g, '').split(',');
    for(let i=0;i<originalEvent.length;i++) {      
       this.eventList.push({label:originalEvent[i],value:originalEvent[i]});
    }

    // Inititalize Default Main Screen Filter Field Values
    this.filterFieldDefaultValues = { type: this.defaultCATEvents };
  }

  ngOnInit(): void {
    this.exportGridColumns = this.GridColumns.filter((Obj:any) => !Obj.excludeFromExport); // Remove Invisible Fields from Export File Field List 

    this.rowcount = this.constantService.DEFAULT_ROWSIZE;
    this.endLimit = this.constantService.DEFAULT_ROWSIZE;
    this.Limit = { 'Start': '0', 'End': this.rowcount };
    /* Dynamically Add Rows Per Page for CAT ROE Viewer Screen screen only */
    this.rowsPerPageOptions = [...this.constantService.DEFAULT_ROWSPERPAGEOPTION];
    this.totalRecords = this.rowcount;
    this.dataset1 = [];
    /*** Get Last CAT Execution date*/
    let todate: any;
    if(this.urlEncodedFilterParams["reportDate"]) {
      todate = this.urlEncodedFilterParams["reportDate"];
    } else {
      todate = this.UserService.CATLastExecutionDate;
    }
    
    this.LastExecutionCATDate = [];
    this.getApplicationFilters(); // Get All Application Filters
    this.multiLegEventArray = this.gridService.getMultiLegEventTypes();
    this.quickFilterEventTypeArray = this.gridService.eventTypes;
    if (todate !== '' || todate !== undefined || todate != null) {
      this.LastExecutionCATDate[0] = (todate); // Fromdate
      this.LastExecutionCATDate[1] = (todate); // Todate
      this.defaultFilter();
    } else {
      this.UserService.get_CAT_Last_ReportDate()
        .subscribe({
          next: (response: any) => {
            let jsondata: any;
            jsondata = response;
            this.UserService.CATLastExecutionDate = jsondata.CATDate;
            todate = jsondata.CATDate;
            this.LastExecutionCATDate[0] = (todate); // Fromdate
            this.LastExecutionCATDate[1] = (todate); // Todate
            this.defaultFilter();
          },  
          error: (e) => {
              console.error(e);
          }
        });
    }
    this.getColumns();
    this.subscription = this.emitterService.reloadMainDashBoard.subscribe(value => {
      if (value) {
        this.getData();
      }
    });
    this.originalEvent = this.constantService.CONVERT_EVENT_LIST.replace(/ /g, '').split(',');
    this.commonColService.init(this.cols, 'CAT-ROE-Viewer');
  }

  closeDialog(value:any) {
    if (value) {
      this.dataService.roeSelectedRecords = [];
      this.getData()
    }
    this.edit = false;
  }
  getColumns() {
    let column: any;
    column = this.GridColumns;
    if (column !== null || column !== undefined) {
      this.cols = this.gridService.getGridColumns(column);
      this.filterCols = this.cols;
    }
  }

  updateDefaultArray($event: any) {
    this.optedApplicationFilter = new Object(); // Unselected Application Filter
    this.emitterService.ResetQuickFilterPanelEvent.emit("All"); // Reset Quick Symbol/Exception-Code Filter
    this.emitterService.isResetGridLimit.emit(true);
    this.DefaultFilterArray = $event;
    this.startLimit = 0;
    this.Limit.Start = 0;
    this.Limit.End = this.rowcount;

    this.getSymbols();
    this.getData();
  }

  clearQuickSearch($event: any) {
    this.optedApplicationFilter = new Object(); // Unselected Application Filter
    this.emitterService.ResetQuickFilterPanelEvent.emit("All"); // Reset Quick Symbol/Exception-Code Filter
    this.emitterService.isResetGridLimit.emit(true);
    this.DefaultFilterArray = $event;
    this.startLimit = 0;
    this.Limit.Start = 0;
    this.Limit.End = this.rowcount;

    this.getSymbols();
    this.getData();
  }

  FilterEventClearSymbol(event: any) {
    this.startLimit = 0;
    this.Limit.Start = 0;

    this.pageNumber = 1;
    this.emitterService.ResetQuickFilterPanelEvent.emit("Symbol");
  }
  FilterEventClearRepresentativeOrder(event:any){
    let representativeIndIdx = this.DefaultFilterArray.findIndex((filterElem:any) => filterElem.columnname.toLocaleLowerCase() === 'representativeind');
    this.startLimit = 0;
    this.Limit.Start = 0;

    this.pageNumber = 1;
    if (!_.isEqual(this.DefaultFilterArray[representativeIndIdx].values, this.gridService.getQuickFilterEventType(this.quickFilterEventType))) {
      this.emitterService.ResetQuickFilterPanelEvent.emit("QuickFilterEventType");
      this.quickFilterEventType = ''
    }  }

  FilterEventClearEventType(event: any) {
    let eventTypeIndex = this.DefaultFilterArray.findIndex((filterElem:any) => filterElem.label.toLocaleLowerCase() === 'type');

    this.startLimit = 0;
    this.Limit.Start = 0;

    this.pageNumber = 1;

    if (!_.isEqual(this.DefaultFilterArray[eventTypeIndex].values, this.gridService.getQuickFilterEventType(this.quickFilterEventType))) {
      this.emitterService.ResetQuickFilterPanelEvent.emit("QuickFilterEventType");
    }
  }

  FilterClearApplicationFilter(event: any = []) {
    this.optedApplicationFilter = new Object();
    this.DefaultFilterArray = [...event];
    this.startLimit = 0;
    this.Limit.Start = 0;
    this.Limit.End = this.rowcount;
    if(event.length > 0) {
      this.getSymbols();
      this.getData();
    } else if(event.length === 0) {
      this.defaultFilter();
      this.emitterService.ReloadQuickFilterPanelEvent.emit('true');
      this.emitterService.isResetGridLimit.emit(true);
      this.emitterService.ResetQuickFilterPanelEvent.emit("All");
    }
    
  }

  FilterApplyFilterEvent(event:any) {
    this.emitterService.isResetGridLimit.emit(true);
    this.DefaultFilterArray = [];
    this.DefaultFilterArray = event;
    this.startLimit = 0;
    this.Limit.Start = 0;
    this.Limit.End = this.rowcount;
    this.getSymbols();
    this.getData();
  }

  getApplicationFilters(filterQueryName?: any) {
    let payload = {
      mpid: this.UserService.getActiveMPID(),
      application: 'CAT-ROE-Viewer',
      isActive: 1
    }

    this.gridService.getApplicationFilterQueries(payload, APIURL.GetApplicationFilterQueries)
    .subscribe({
      next: (Element:any) => {
        let dataResultSet: any = Element;
        this.applicationFilters = dataResultSet.Data;
        if(filterQueryName != undefined && filterQueryName != null) {
          let createdApplicationFilter = this.applicationFilters.filter((res:any) => res.filter_query_name === filterQueryName);
          this.optedApplicationFilter = createdApplicationFilter && createdApplicationFilter[0];
          if(Object.keys(this.optedApplicationFilter).length > 0) {
            this.setActiveApplicationFilter(this.optedApplicationFilter);
          }
        }
      },
      error: (err: HttpErrorResponse) => {        
      }
    });
  }

  onRowSelect(value: any, index: any, rowData:any) {
    this.dataService.roeSelectedRecords = this.dataService.checkRowExistanceInList(rowData, this.dataService.roeSelectedRecords, 'firmROEID'); // Check Row Object Existance in selected Row Object List
    if (this.dataService.roeSelectedRecords.length <= 1) {
      this.dataService.roeSelectedRecords = [];
      this.dataService.roeSelectedRecords[0] = (rowData)
    }
    this.correctCodeLength = 0;
    if (value == 'edit' || value == 'View'){
      if (this.dataService.roeSelectedRecords.length > 1) {
        this.validateMultiEdit(rowData, index);
      }
      else {
        this.isMultiEdit = false;
          this.edit = true;
      }
      this.rowDataforDialog = rowData;
      this.rowIndexForDialog = index;
      this.actionType = value;
    }else{
        this.dataService.roeSelectedRecords = [];
        this.dataService.roeSelectedRecords[0] = (rowData)
    if (value == 'OrderID') {
      if (this.quickFilterEventType === 'Representative Orders') {
        this.isRepresentativeOrderDisplay = true;
      }
      else {
        this.emitterService.isOrderViewerOpenCloseEvent.emit(
          {
            display: true,
            rowData: rowData,
            pageName: 'CAT-ROE'
          });
      }
    } else if (value == 'EventTree') {
      this.eventTreeService.isDialogOpen = true;
      this.openTree(rowData);
    } else if (value == 'AuditTrail') {
      this.onAuditTrail(rowData);
    }
  }
  }

  validateMultiEdit(rowData:any, index:any) {
    this.firmROEIDList = [];
    this.dataService.roeSelectedRecords.forEach((row:any) => {
      if (this.dataService.roeSelectedRecords[0].type === row.type) {
        this.correctCodeLength = this.correctCodeLength + 1
      } else {
        this.correctCodeLength = this.correctCodeLength - 1
      }
    });

    if (this.dataService.roeSelectedRecords.length === this.correctCodeLength) {
      this.isMultiEdit = true;
      this.dataService.roeSelectedRecords.forEach((element:any) => {
        this.firmROEIDList.push(element.firmROEID)
      });
      this.actionType = 'edit';
      this.edit = true;
      this.rowDataforDialog = rowData;
      this.rowIndexForDialog = index;
    } else {
      // this.Edit = false
      this.correctCodeLength = 0;
      this.isMultiEdit = false;
      this.confirmationService.confirm({
        message: 'Selected records must have same  Event type ',
        key: 'informationDialoge',
        header: 'Information',
        acceptLabel: 'Ok',
        acceptIcon:'pi pi-check',
        rejectVisible : false,
        acceptButtonStyleClass:"confirm-dialog-button",
        rejectButtonStyleClass:"confirm-dialog-button",
        accept: () => {
          this.edit=false;
        },
        reject: () => {
          this.edit=false;
        }
      });

    }
  }
  setActiveSymbolEvent(event: any) {
    this.ActiveSymbol = event;
    for (let i = 0; i < this.DefaultFilterArray.length; i++) {
      if (this.DefaultFilterArray[i].label.toLocaleLowerCase() === 'symbol') {
        this.DefaultFilterArray[i].values = this.ActiveSymbol;
        this.DefaultFilterArray = [...this.DefaultFilterArray];
        this.startLimit = 0;
        this.Limit.Start = 0;
        this.totalRecords = 0;
        this.emitterService.ReloadQuickFilterPanelEvent.emit('true');
        this.emitterService.isResetGridLimit.emit(true);
        this.getData();
        break;
      }
    }
  }

  setActiveQuickFilterEventType(event: any) {
    this.quickFilterEventType = event;
    let eventTypeIndex = this.DefaultFilterArray.findIndex((filterElem:any) => filterElem.label.toLocaleLowerCase() === 'type');
    let representativeIndIdx = this.DefaultFilterArray.findIndex((filterElem:any) => filterElem.columnname.toLocaleLowerCase() === 'representativeind');

    if (this.quickFilterEventType === 'Representative Orders') {
      this.DefaultFilterArray[representativeIndIdx].values = "Y,YS,O,OS"
      this.DefaultFilterArray[representativeIndIdx].filterby = "IN"
    }else{
      this.DefaultFilterArray[representativeIndIdx].values = ""
    }

    this.DefaultFilterArray[eventTypeIndex].values = this.gridService.getQuickFilterEventType(this.quickFilterEventType);

    this.DefaultFilterArray = [...this.DefaultFilterArray];
    this.startLimit = 0;
    this.Limit.Start = 0;
    this.emitterService.ReloadQuickFilterPanelEvent.emit('true');
    this.emitterService.isResetGridLimit.emit(true);
    this.getSymbols();
    this.getData();
  }

  setActiveApplicationFilter(optedFilterQuery: any) {
    this.optedApplicationFilter = optedFilterQuery;
    let DateFilterObj = this.DefaultFilterArray.filter((res:any) => res.label === 'Date');
    let optedFilterData = [...DateFilterObj, ...JSON.parse(optedFilterQuery.filter_queries)];

    this.emitterService.isResetGridLimit.emit(true);
    this.DefaultFilterArray = [];
    this.DefaultFilterArray = optedFilterData;
    this.startLimit = 0;
    this.Limit.Start = 0;
    this.Limit.End = this.rowcount;
    this.getSymbols();
    this.getData();

    this.emitterService.ResetQuickFilterPanelEvent.emit("All");
  }

  RemoveOptedApplicationFilter(optedFilterQuery: any) {
    let payloadData = {
      mpid: this.UserService.getActiveMPID(),
      application: 'CAT-ROE-Viewer',
      id: optedFilterQuery.id,
      filterQueryName: optedFilterQuery.filter_query_name,
      usedBy: this.UserService.getUserName()
    }
    this.confirmationService.confirm({
      message: 'This saved filter query might be used by other users. Are you sure you want to delete this filter query ?',
      key: 'confirmationDialoge',
      header: 'Information',
      acceptLabel: 'Yes',
      acceptIcon:'pi pi-check',
      defaultFocus: 'reject',
      rejectLabel: 'No',
      rejectIcon:'pi pi-times',
      acceptButtonStyleClass:"confirm-dialog-button",
      rejectButtonStyleClass:"confirm-dialog-button",
      accept: () => {
        this.messageService.add({severity: 'info', summary: 'Removing Application Filter', detail: 'Please wait while deleting Application Filter...'});
        this.gridService.deleteApplicationFilterQuery(payloadData, APIURL.DeleteApplicationFilterQuery)
        .subscribe({
          next: (Element:any) => {
            let dataResultSet: any = Element;
            if(dataResultSet.status) {
              this.messageService.add({ severity: 'success', summary: 'Delete Message', detail: dataResultSet.message });
              this.UserService.logUserActivity('Delete Filter Query', null, {
                'Text1': dataResultSet.message + ' | ' + 'User ' + this.UserService.getUserName() + ' deleted filter query by Name: ' + optedFilterQuery.filter_query_name,
                'Text2': 'User Opted Filter Query Parameters: ' + optedFilterQuery.filter_queries
              });
            }
            this.getApplicationFilters();
            (Object.keys(this.optedApplicationFilter).length > 0 && this.optedApplicationFilter.id===optedFilterQuery.id && this.optedApplicationFilter.filter_query_name.trim() === optedFilterQuery.filter_query_name.trim()) && this.FilterClearApplicationFilter();
          },  
          error: (err: HttpErrorResponse) => {
          }
        });
      }
    });
  }

  GridResetSymbolEvent(event: any) {
    this.startLimit = 0;
    this.Limit.Start = 0;
    this.Limit = { 'Start': this.startLimit, 'End': this.rowcount };
    this.emitterService.ResetQuickFilterPanelEvent.emit('All');
  }

  GridChangeLimitEvent(event: any) {
    this.Limit = event;
    this.getData();
  }

  defaultFilter() {
    this.DefaultFilterArray = [
      { 'isdefault': 'true', 'label': 'Date', 'columnname': 'eventTimestamp', 'filterby': '', 'values': this.LastExecutionCATDate, 'time': '', 'datatype': 'DateRange', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'type', 'columnname': 'type', 'filterby': 'IS', 'values': this.defaultCATEvents, 'time': '', 'datatype': 'skip', 'disabled': 'true', 'dropdown': 'YES', 'dropdowntype': 'multiselect', 'dropdownvalue': this.CATFieldTypesArrayList },
      {
        isdefault: 'true',
        label: 'Rsms Status',
        columnname: 'rsmsStatus',
        filterby: 'IN',
        values: [],
        time: '',
        datatype: 'Array',
        disabled: 'true',
        dropdown: 'YES',
        dropdowntype: 'multiselect',
        dropdownvalue: this.constantService.rsmsStatusDropDwn,
      },
      { 'isdefault': 'true', 'label': 'Firm ROEID', 'columnname': 'firmROEID', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Symbol', 'columnname': 'symbol', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Quantity', 'columnname': 'quantity', 'filterby': '=', 'values': '', 'time': '', 'datatype': 'Int', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Price', 'columnname': 'price', 'filterby': '=', 'values': '', 'time': '', 'datatype': 'Float', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Order ID', 'columnname': 'orderID', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Route ID', 'columnname': 'routedOrderID', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Trade ID', 'columnname': 'tradeID', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'AllocationID', 'columnname': 'allocationID', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Destination', 'columnname': 'destination', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Order Date', 'columnname': 'orderKeyDate', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'RepresentativeInd', 'columnname': 'representativeInd', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Firm Designated ID', 'columnname': 'firmDesignatedID', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'GroupName', 'columnname': 'groupName', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' }
    ];

    let urlDecodedFilterParams: object | any= new Object();
    this.activatedRoute.queryParams
    .subscribe({
      next: (params: any) => {
        if (Object.keys(params).length > 0) {
          urlDecodedFilterParams = JSON.parse(atob(Object.keys(params)[0]));
          let fieldName = ((urlDecodedFilterParams && urlDecodedFilterParams["fieldName"]) ? urlDecodedFilterParams["fieldName"] : undefined);
          let value = ((urlDecodedFilterParams && urlDecodedFilterParams["fieldValue"]) ? urlDecodedFilterParams["fieldValue"] : undefined);
          let eventType = ((urlDecodedFilterParams && urlDecodedFilterParams["eventType"]) ? urlDecodedFilterParams["eventType"] : undefined);
          let groupName = ((urlDecodedFilterParams && urlDecodedFilterParams["groupName"]) ? urlDecodedFilterParams["groupName"] : undefined);
          let filterBy: any;
          let dropDownValue: Array<any> = [];
          let gridArray: any = this.GridColumns;

          gridArray.forEach((element: any) => {
            if (element.mappingkey === fieldName) {
              let datatype = element.datatype.toLocaleLowerCase()
              if (datatype == "int" || datatype == "float" || datatype == "time" || datatype == "datetime"
                || datatype == "boolean") {
                filterBy = '=';
                if (datatype == "boolean") {
                  dropDownValue = [
                    { label: 'True', value: 'true' },
                    { label: 'False', value: 'false' }
                  ]
                }
              } else if (datatype == "string" || datatype == "char") {
                filterBy = 'IS';
                if (fieldName === 'handlingInstructions' || fieldName === 'timeInForce') {
                  filterBy = 'LIKE';
                  value = '%' + value + '":%'
                }
              } else if (datatype == "array") {
                filterBy = [];
              }
              let indexForEventTypeValue = this.DefaultFilterArray.findIndex(function (item: any, i: any) {
                return item.label === fieldName;
              });
              if (indexForEventTypeValue > 0 && value != undefined && this.DefaultFilterArray[indexForEventTypeValue] != undefined) {
                if (fieldName === "type") {
                  this.DefaultFilterArray[indexForEventTypeValue].values = [value];
                } else {
                  this.DefaultFilterArray[indexForEventTypeValue].label = fieldName;
                  this.DefaultFilterArray[indexForEventTypeValue].columnname = fieldName;
                  this.DefaultFilterArray[indexForEventTypeValue].values = value;
                }
              } else if (indexForEventTypeValue == -1) {
                let values: any = [];
                this.DefaultFilterArray[1].dropdownvalue.map((item: any) => {
                  values.push(item.value);
                })
                this.DefaultFilterArray[1].values = values;
              }

              let indexForGroupNameValue = this.DefaultFilterArray.findIndex(function (item: any, i: any) {
                return item.columnname == "groupName";
              });
              if (indexForGroupNameValue > 0 && groupName != undefined && groupName != "undefined") {
                this.DefaultFilterArray[indexForGroupNameValue].values = groupName;
              }

              if (indexForEventTypeValue == -1 && value != undefined) {
                this.DefaultFilterArray.push({
                  'isdefault': 'true', 'label': fieldName, 'columnname': fieldName,
                  'filterby': filterBy, 'values': value, 'time': '',
                  'datatype': element.datatype, 'disabled': 'false', 'dropdown': dropDownValue.length > 0 ? 'YES' : '',
                  'dropdownvalue': dropDownValue.length > 0 ? dropDownValue : ''
                });
              }

              if (eventType !== undefined) {
                this.DefaultFilterArray[1].values = [];
                this.DefaultFilterArray[1].values.push(eventType);
              }

            }
          });
        }
      },
      error: (e) => {
        console.error(e);
      }
    });
    this.getSymbols();
    this.getData();
  }

  changePage(event:any) {
    this.startLimit = event.first;
    this.rowcount = event.rows;
    this.endLimit = this.startLimit + this.rowcount;

    if (this.endLimit > this.totalRecords) {
      this.endLimit = this.totalRecords;
    }
    this.Limit = { 'Start': this.startLimit, 'End': this.rowcount };
    this.priviousStartLimit = this.startLimit;
    this.pageNumber = Math.round(this.startLimit / this.rowcount) + 1;
    this.getData();
  }

  getSymbols() {
    this.gridService.getSymbol(APIURL.QuickFilterFields, this.DefaultFilterArray, this.Limit, 'CAT-ROE-Viewer')
      .subscribe({
        next: (Element: any) => {
          let Symbol: any;
          Symbol = Element;
          this.SymbolsArray = [];
          this.SymbolsArray = Symbol.SymbolList;
        },
        error: (e) => {
            console.error(e);
        }
      });  
  }
  getFieldDictionary() {
    this.CATFieldTypesArrayList = this.UserService.getDropDownList('type');
  }
  getData() {
    this.correctCodeLength = 0;
    this.dataService.roeSelectedRecords = [];
    this.dataset1 = [];
    this.isLoadingResults = true;
    this.Limit = { 'Start': this.startLimit, 'End': this.rowcount };
    this.previousLimit = this.Limit;
    this.tbldatamsg = 'L o a d i n g . . . . .';
    /* ** set post dataset */
    this.gridService.getData(
      APIURL.CAT_ROE_Viewer,
      this.DefaultFilterArray,
      this.Limit,
      this.gridService.getEventsList(this.DefaultFilterArray, 'type'),
      'CAT-ROE'
    )   
    .subscribe({
      next: (Element:any) => {
        this.isLoadingResults = false;
          let dataset: any;
          dataset = Element;
          this.dataset1 = dataset.Data;
          this.defaultData = this.dataset1;
          this.dataset1 = _.orderBy(_.sortBy(this.dataset1, this.sortData.field), [this.sortData.field], [this.sortData.order]);
          this.totalRecords = dataset.totalCount;
          this.totalRecords = this.gridService.handleNoRecordsPageNumber(this.totalRecords);
          this.displayTildCount = true;

          if (this.dataset1.length === 0) {
            this.tbldatamsg = 'No data found';
          }
          this.gridService.getData(
            APIURL.CAT_ROE_Viewer_Count,
            this.DefaultFilterArray,
            this.Limit,
            this.gridService.getEventsList(this.DefaultFilterArray, 'type'),
            'CAT-ROE'
          )   
          .subscribe({
            next: (Element:any) => {
              this.isLoadingResults = false;
              this.displayTildCount = false;
                let dataset: any;
                dataset = Element;
                this.defaultData = this.dataset1;
                this.totalRecords = dataset.totalCount;
                this.totalRecords = this.gridService.handleNoRecordsPageNumber(this.totalRecords);

            },
            error: (err: HttpErrorResponse) => {
              this.isLoadingResults = false;
              this.tbldatamsg = 'No data found';
            }
          });
      },
      error: (err: HttpErrorResponse) => {
        this.isLoadingResults = false;
        this.tbldatamsg = 'No data found';
      }
    });

    
  }

  getString(value:any) {
    return JSON.stringify(value);
  }
  exportToCSV(event:any) {
    if(this.UserService.enableFileExport()){
    let initialTime = new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit'});
    // to let user know the button is clicked and download process is started
    this.messageService.add({ severity: 'info', summary: 'File', detail: 'Please wait.. Preparing export file to download..' });

    let csvExportData;
    if (event.isExportMaxRows) {
      this.Limit = { 'Start': this.constantService.NUMBER_0, 'End': this.constantService.NUMBER_MAX_EXPORT_ROWS };
    } else {
      csvExportData = JSON.parse(JSON.stringify(this.dataset1));
      this.Limit = this.previousLimit;
    }

    const filterData = JSON.parse(JSON.stringify(this.DefaultFilterArray));
    filterData[0].values[0] = this.UserService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[0])));
    filterData[0].values[1] = this.UserService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[1])));

    const exportCSVPayload = {
      "data": JSON.parse(JSON.stringify(filterData)),
      "mpid": this.UserService.getActiveMPID(),
      "startLimit": this.Limit.Start + "",
      "endLimit": this.Limit.End + "",
      "pageName": 'CAT-ROE',
      "eventType": this.gridService.getEventsList(this.DefaultFilterArray, 'type'),
      "CSVExportData": csvExportData
    };
    this.sharedHttpClientService.post(
      this.urlService.setAPIURl(APIURL.CAT_EXPORT_CSV),
      exportCSVPayload
    ).pipe(map((response: Response) => {
        return response;
    }))
    .subscribe({
      next: (Element:any) => {
      this.isLoadingResults = false;
      let dataset: any = Element;
      let data = dataset.Data;
      if (data.length > 0) {
        data.forEach((col:any) => {
          delete col.originalJSON;
          col.timeInForce = (typeof col.timeInForce === 'object' ? JSON.stringify(col.timeInForce) : col.timeInForce);
          col.handlingInstructions = (typeof col.handlingInstructions === 'object' ? JSON.stringify(col.handlingInstructions) : col.handlingInstructions);
          col = this.gridService.formatMultiDimensionalColumns(col, this.gridService.multiDimensionalColumns);
        });
        const filename= this.UserService.getActiveMPID() + '_RSMS_CAT_ROE_Viewer_' + this.UserService.getyyyyMMdd_HH_MM_SSDateFormate(new Date());
        const options:any = {
          fieldSeparator: ',',
          quoteStrings: '"',
          decimalSeparator: '.',
          showLabels: true,
          showTitle: true,
          title: 'RSMS_CAT_ROE_Viewer_' + this.UserService.getyyyyMMddDateFormate(new Date()),
          useTextFile: false,
          useBom: true,
          useKeysAsHeaders: true,
          filename: filename
        };
        const csv = generateCsv(options)(this.constantService.getExportData(data, event.gridColumn));
        const blob = asBlob(options)(csv);
        saveAs(blob, filename);
        this.messageService.add({ severity: 'success', summary: 'File', detail: 'File Download Successfully' });
        this.UserService.logUserActivity('Export CSV', null, {
          'Text1': 'File Download Successfully | ' + (data.length > 0 ? data.length : 0) + ' records downloaded with file name: ' + options.filename + ' with start time: ' + initialTime + ' and end time: ' + new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit'}),
          'Text2': 'User Filter Parameters: ' + JSON.stringify(filterData.filter((filterParam:any) => (filterParam.values != '' || filterParam.values.length > 0)))
        });
      } else {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No data found' });
        this.UserService.logUserActivity('Export CSV', null, {
          'Text1': 'No data found',
          'Text2': 'User Filter Parameters: ' + JSON.stringify(filterData.filter((filterParam:any) => (filterParam.values != '' || filterParam.values.length > 0)))
        });
      }
      this.emitterService.exportToCSVData.emit(true);
      },
      error: (err: HttpErrorResponse) => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error while Exporting' });
        this.UserService.logUserActivity('Export CSV', null, {
          'Text1': 'Error while Exporting',
          'Text2': 'User Filter Parameters: ' + JSON.stringify(filterData.filter((filterParam:any) => (filterParam.values != '' || filterParam.values.length > 0)))
        });
      }
    });   
  }
}

  /**
   * to prepare and return data for passing to cat0rie-viewer api
   * @param filterArray default filter array 
   * @param limit start and end date
   * @param pageName which page is the date being called for
   * @returns dataFilter object that is sent to CAT-ROE-VIEWER
   */
  preparePayload(filterArray:any, limit: any, eventType:any, pageName: any) {
    /* ** set post dataset */
    if (limit.End == 0 && limit.End == '' && limit.Start == '') {
      this.gridService.getGridRowsCount();
      limit.End = this.rowcount;
      limit.Start = 0;
    }

    const filterData = JSON.parse(JSON.stringify(filterArray));

    if (this.router.url.indexOf('FDID') === -1 && this.router.url.indexOf('Customer-Info') === -1) {
      filterData[0].values[0] = this.UserService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[0])));
      filterData[0].values[1] = this.UserService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[1])));
    }

    return {
      "data": filterData,
      "mpid": this.UserService.getActiveMPID(),
      "startLimit": limit.Start + "",
      "endLimit": this.totalRecords + "",
      "pageName": pageName,
      "eventType": eventType,
      "startDate": filterData[0].values[0],
      "endDate": filterData[0].values[1]
    };
  }

  /**
   * export functionality to export selected roe records
   * exporting in the json format
   */
  exportToJSON(): void {
    if(this.UserService.enableFileExport()){
    let initialTime = new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit'});
    this.isExportToJSON = true;
    // to let user know the button is clicked and download process is started
    this.messageService.add({
      severity: 'info',
      summary: 'File',
      detail: 'Please wait.. Preparing export file to download..'
    });

    // timestamp
    let timeStamp = this.datePipe.transform(new Date(), 'yyyyMMddHHmmss');

    // set date-range text for file name(only one date of start and end date are the same)
    let dateRangeText = this.datePipe.transform(this.DefaultFilterArray[0].values[0], 'yyyy-MM-dd');

    // mention the start and end date separately if different
    if (this.DefaultFilterArray[0].values[0].toJSON() != this.DefaultFilterArray[0].values[1].toJSON()) {
      dateRangeText += "_to_" + this.datePipe.transform(this.DefaultFilterArray[0].values[1], 'yyyy-MM-dd');
    }
    // declare payload
    let payload = this.preparePayload(
      this.DefaultFilterArray,
      this.Limit,
      this.gridService.getEventsList(this.DefaultFilterArray, 'type'),
      'CAT-ROE'
    );
    this.sharedHttpClientService.postPlainText(
      this.urlService.setAPIURl(APIURL.CAT_ROE_Viewer_Export_Json),
      payload
    )
    .subscribe({
      next: (response:any) => {
        const blob = new Blob([response], { type: 'application/octet-stream' });
        let filename = timeStamp + "_" + this.UserService.getActiveMPID() + "_" + dateRangeText + ".json";
        saveAs(blob, filename);
        this.messageService.add({ severity: 'success', summary: 'File', detail: 'File Download Successfully' });
        this.UserService.logUserActivity('Export JSON', null, {
          'Text1': 'File Download Successfully | ' + (this.totalRecords > 0 ? this.totalRecords : 0) + ' records downloaded with file name: ' + filename + ' with start time: ' + initialTime + ' and end time: ' + new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit'}),
          'Text2': 'User Filter Parameters: ' + JSON.stringify(this.DefaultFilterArray.filter((filterParam:any) => (filterParam.values != '' || filterParam.values.length > 0)))
        });
      },
      error: (err: HttpErrorResponse) => {
        this.messageService.add({ severity: 'warn', summary: 'File', detail: 'File Download Failed.' });
          this.UserService.logUserActivity('Export JSON', null, {
            'Text1': 'File Download Failed',
            'Text2': 'User Filter Parameters: ' + JSON.stringify(this.DefaultFilterArray.filter((filterParam:any) => (filterParam.values != '' || filterParam.values.length > 0)))
          });
        }
      });
    this.isExportToJSON = false;
    }
  }

  openTree(rowData:any) {
    this.eventTreeService.isDialogOpen = true;
    this.selectedRow[0] = rowData;
  }
  sort(event:any) {
    if (this.commonColService.isCtrlPressed|| this.commonColService.isDragging || this.commonColService.selectedFields.length > 1) {
    this.dt.multiSortMeta =[];
    this.dt.sortField = '';
    this.dt.sortOrder = 0;
    return;
  }
    if (this.sortClickCounter !== 3 && (this.sortData.field === "" || this.sortData.field === event.multisortmeta[0].field)) {
      this.sortClickCounter = this.sortClickCounter + 1;
    } else {
      this.sortClickCounter = 1;
    }
    if (this.sortClickCounter !== 3) {
      let sortOrder = event.multisortmeta[0].order === 1 ? 'asc' : 'desc';
      this.sortData.field = event.multisortmeta[0].field;
      this.sortData.order = sortOrder;
      this.dataset1 = this.sortPipe.transform(this.dataset1, this.sortData.order, this.sortData.field);
    } else {
      this.resetSort()
    }

  }
  resetSort() {
    this.dt.multiSortMeta[0].field = '';
    this.dt.multiSortMeta[0].order = 0;
    this.dataset1 = this.defaultData;
  }

  onAuditTrail(rowData:any) {
    this.isAuditTrail=true;
      this.selectedRow = [];
      this.selectedRow[0] = rowData
  }

  onClickMultiLegEvent(index: any, rowData:any) {
    if (this.dataService.roeSelectedRecords.length <= 1) {
      this.dataService.roeSelectedRecords = [];
      this.dataService.roeSelectedRecords[0] = (rowData);
    }
    this.rowDataforDialog = rowData;
    this.rowIndexForDialog = index;
    this.viewMultiLegEvent = true;
  }

  closeMultiLegEvent(e:any) {
    this.viewMultiLegEvent = false;
  }
  
  cloneFinraException(rowData:any){
    this.dataService.roeSelectedRecords = this.dataService.checkRowExistanceInList(rowData, this.dataService.roeSelectedRecords, 'firmROEID'); // Check Row Object Existance in selected Row Object List
    if (this.dataService.roeSelectedRecords.length <= 1) {
      this.dataService.roeSelectedRecords = [];
      this.dataService.roeSelectedRecords[0] = (rowData);
    }
    this.confirmationService.confirm({
      message: 'With this action, you will be able to correct selected ROE(s) from FINRA Exception screen. Proceed?',
      header: 'Confirmation',
      acceptLabel: 'Yes',
      acceptIcon:'pi pi-check',
      defaultFocus: 'accept',
      rejectLabel: 'No',
      rejectIcon:'pi pi-times',
      acceptButtonStyleClass:"confirm-dialog-button",
      rejectButtonStyleClass:"confirm-dialog-button",
      accept: () => {
        this.messageService.add({
          severity: 'info',
          summary: 'Moving Records',
          detail: 'Please wait... It will take a few minutes to moving records into Finra Exception'
        });
        this.moveRecordsToFinraException();
      }
    });
  }

  moveRecordsToFinraException(){
    let Data = {
        'records':this.dataService.roeSelectedRecords,
        'mpid': this.UserService.getActiveMPID(),
        'user': this.UserService.getUserName()
    };
     this.sharedHttpClientService.post(this.urlService.setAPIURl(APIURL.CAT_ROE_Move_To_FinraException), Data)
        .pipe(map((response: Response) => {
            return response;
        }))
        .subscribe({
          next: (response:any) => {
            this.isLoadingResults = false;
              let data:Promise<any> | any=response;
              let moved=0,failed=0;
              for(let i=0;i<Object.keys(data).length;i++)
              {
              if(data[i].status==false){
                failed++;
              }else{
                moved++;
              }
              }
              this.messageService.add({
                severity: 'success',
                summary: 'Moved Records',
                detail: 'Records Moved: '+moved+' into Finra Exception Successfully. Failed : '+failed,
              });
          },  
          error: (err: HttpErrorResponse) => {
            this.isLoadingResults = false;
          }
        });
  }

  onEventTypeChange(e:any) {
    if(this.dataService.roeSelectedRecords.length == 0){
      this.selectedRow=[];
    }
    if(e.value != null && e.value != undefined){
      this.selectedEventType = e.value;  
      if (this.selectedRow.length == 1) {
        this.selectedID = this.selectedID;
        this.existingEventType= this.selectedRow[0].type;
        this.pageName='CAT-ROE-Viewer'; 
        } else{
          this.selectedID = null;
          this.pageName='CAT-ROE-Viewer';   
        }
        this.displayDropdownTypeBySelectedType(this.selectedRow[0]);   
        this.displayNewROEDialog = true;
    } else{
      this.displayNewROEDialog = false;
    }
  }

  ngOnDestroy() {
    if (this.subscription)
      this.subscription.unsubscribe();
  }

  displayDropdownTypeBySelectedType(selectedRecord:any){  
    if(selectedRecord == undefined){
      selectedRecord = [];
    }    
   
    this.selectedRow[0] = selectedRecord;    
    let selectedRow1 :any = this.dataService.checkRowExistanceInList(selectedRecord, this.selectedRow, 'firmROEID'); // Check Row Object Existance in selected Row Object List
    this.selectedRow = selectedRow1;
    selectedRow1 = selectedRow1[0];  
    if(selectedRow1 == undefined){
      return;
    }
    if(this.dataService.roeSelectedRecords.length > 1){
      this.eventList = this.constantService.populateEventList("ML");
      return;
    } 
    this.selectedID = selectedRow1.firmROEID;
    this.selectedReportDate = selectedRow1.reportDate;
    this.selectedEventType = this.selectedEventType;
    this.existingEventType = selectedRow1.type;
    this.selectedGroupName = selectedRow1.groupName;
    this.CATReporterIMID=selectedRow1.CATReporterIMID;
    this.eventList = []; 
    this.eventList = this.constantService.populateEventList(this.existingEventType);
  }
  
  closeDropdown(e:any){
    this.displayNewROEDialog = false;
    this.id_newROEEntry.clear();
  }

}